import { render } from "./tabbar.vue?vue&type=template&id=64357b52&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=ts"
export * from "./tabbar.vue?vue&type=script&lang=ts"

import "./tabbar.vue?vue&type=style&index=0&id=64357b52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64357b52"

export default script